import { Col, Row, Spin } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'

export const ShortListModalImg = styled.div`
  text-align: center;
  margin-bottom: 25px;
`
export const ModalText = styled.div`
  color: #010e30;
  text-align: center;
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 25px;
`
export const ButtonDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
`
export const StyledSpin = styled(Spin)`
  .ant-spin-dot-item {
    background-color: #5db594;
  }
`

export const StyledDivision = styled.div`
  width: 100%;
  line-height: 1.5;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 11px;
`
export const EventName = styled.div`
  font-size: 24px;
  font-weight: 700;
`
export const Size = styled.span`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 10px;
  font-weight: 500;
  padding-bottom: 20px;
  margin-top: 23px;
  margin-left: 5px;
`
export const Uploaders = styled.div`
  display: flex;
  align-items: center;
  width: 235px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  height: 44px;
  border-radius: 8px;
  margin-bottom: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: 2px solid ${props => props.borderColor};
  background-color: white;
  color: ${props => props.textColor};
  cursor: pointer;
`
export const EventSection = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  gap: 10px;
`

export const EventRegistration = styled.div`
  border: 1px solid ${props => props.styleBasedObj?.borderColor};
  border: 2px solid ${props => props.borderColor};
  background-color: white;
  color: ${props => props.textColor};
  border-radius: 17px;
  padding: 10px 15px;
  // color: ${props => (props.darkBG ? props.styleBasedObj?.color : '#000')};
`

export const EventRegistrationText = styled.div`
  font-size: 14px;
  font-weight: ${props => props?.weight ?? 700};
  text-align: left;
`

export const MainDiv = styled.div`
  width: 93%;
  border: #d8ddff 2px solid;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  background-color: ${({ className }) => {
    switch (className) {
      case 'primary':
        return '#B6BDFF40'
      case 'secondary':
        return '#FFB6C140'
      case 'tertiary':
        return '#C1FFC140'
      default:
        return '#B6BDFF40'
    }
  }};
  border-color: ${({ className }) => {
    switch (className) {
      case 'primary':
        return '#d8ddff'
      case 'secondary':
        return '#ffb6c1'
      case 'tertiary':
        return '#c1ffc1'
      default:
        return '#d8ddff'
    }
  }};
  margin-left: 21px;
  margin-top: 25px;
  margin-bottom: 20px;
  margin-right: 21px;
`
export const StudentDiv = styled.div`
  font-size: 20px;
  padding-top: 30px;
`
export const EventLabel = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-align: left;
  padding-bottom: 12px;
`
export const EventLabel1 = styled.div`
  margin-top: 4px;
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
`

export const EventData = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;

  a {
    color: blue;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`
export const EventData1 = styled.div`
  font-family: Plus Jakarta Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 18px;
  text-align: left;
`

export const Category = styled.span`
  font-size: 24px;
  font-weight: 400;
`

export const EventDatecard = styled.div`
  width: 271px;
  height: ${props => (props.hasTime ? '58px' : '43px')};
  border-radius: 47px;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  border: 2px solid ${props => props.borderColor};
  background-color: ${props => props.backgroundColor};
  color: ${props => props.textColor};
`
export const StyledButton = styled.button`
  width: 86px;
  height: 31px;
  border-radius: 22.5px;
  background-color: #007bff; /* Example background color */
  color: #fff; /* Example text color */
  border: none;
  cursor: pointer;
`
export const VerticalDivider = styled.div`
  height: 28px;
  border-left: 1.3px solid #007bff;
`
export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
`
export const StyledButton1 = styled.button`
  width: 86px;
  height: 31px;
  border-radius: 22.5px;
  color: #fff;
  border: none;
  cursor: pointer;
  color: black;
  border: 1px solid #007bff;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
`

export const Right = styled(Flex)`
  justify-content: flex-end;
  padding-right: 19px;
  padding-bottom: 20px;
  margin-top: -20px;
`
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 5px;
  width: 500px;
  max-width: 100%;
`

export const ModalCheckbox = styled.div`
text-align: center;
gap: 10px;
position: relative;
margin-top: -22px;
padding: 10px;
font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 17.64px;
  color: #A5A5A5;

}
`

export const StyledCol = styled(Col)(({ justify = 'start' }) => ({
  display: 'flex',
  justifyContent: justify,
}));

export const StyledRow = styled(Row)(() => ({
  gap: '2rem',
}))

export const StyledFileCol = styled(Col)(() => ({
  display: 'flex',
  alignItems: 'end',
  gap: '2px',
  border: '1px solid rgba(50, 73, 215, 1)',
  background: 'rgba(250, 250, 251, 1)',
  padding: 10,
  borderRadius: 8,
  marginTop: 2,
}))

export const PreviewTitle = styled('div')(() => ({
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '20px',
  marginBottom: '4px',
}))

export const PreviewAnswer = styled('div')(() => ({
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
}))

export const LinkedInLink = styled('a')(() => ({
  color: 'rgba(50, 73, 215, 1)',
  fontSize: ' 14px',
  fontWeight: 700,
  lineHeight: '30px',
}))

export const DetailsSection = styled(Col)(() => ({
  fontSize: '14px',
  fontWeight: 700,
  lineHeight: '20px',
}))

export const FileIconSec = styled('div')(() => ({
  //   display: 'flex',
  //   alignItems: 'center',
  //   gap: 10,
}))

export const FileName = styled('div')(() => ({
  color: 'rgba(50, 53, 56, 1)',
  fontSize: 14,
  fontWeight: 500,
}))

export const FileSize = styled('div')(() => ({
  color: 'rgba(50, 53, 56, 1)',
  fontSize: 10,
  fontWeight: 500,
}))

export const DownloadIconSec = styled('div')(() => ({
  marginLeft: 'auto',
  cursor: 'pointer',
}))

export const RegistrationText = styled('div')(() => ({
  fontSize: '12px',
  fontWeight: 700,
}))

export const ShowMoreText = styled.span`
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #000;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  border-radius: 10px;
  // background-color: #f0f2f4;
  font-weight: bold;
`

export const Container1 = styled.div`
  height: ${props => (props.expanded ? 'auto' : '250px')};

  overflow: hidden;
  overflow-wrap: break-word;
`

export const Content = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #808697;
`

export const ExtraPadding = styled.div`
  padding-bottom: 8px;
`
export const ShowLessText = styled.span`
  cursor: pointer;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  color: #000;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  border-radius: 10px;
  // background-color: #e6e7ea;
  width: 25% !important;
  font-weight: bold;
`
export const EventData4 = styled.div`
  font-family: 'Plus Jakarta Sans', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
  text-align: left;
  text-color: black;

  a {
    color: blue;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`
